function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "shoeprints"
}, /*#__PURE__*/React.createElement("path", {
  id: "original",
  d: "M 13.01798,25.39451 C 12.77399,25.64089 7.253,23.65425 7.18568,23.16408 6.35644,17.1269 10.30763,12.32575 14.15474,12.10585 c 4.51136,-0.25788 3.02218,9.08888 -1.13676,13.28866 z m -6.24402,9.15377 c -1.75334,-0.64849 -2.22119,-3.43642 -1.02572,-7.0593 0.23575,-0.71443 6.23884,1.28298 6.15248,1.91291 -0.6586,4.80359 -3.37343,5.79488 -5.12676,5.14639 z"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#original",
  id: "copy",
  transform: "matrix(-0.60808092,-0.79387506,-0.79387506,0.60808092,52.157707,10.212769)"
}));

var SvgFootstepsIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    id: "footsteps",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFootstepsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/footsteps_icon.9ddb1a00.svg";
export { ForwardRef as ReactComponent };